<script setup>
import { SETTING_DEFINITIONS_CATEGORIES } from "@/constants/constants";
import useClients from "@/hooks/useClients";
import { computed, onMounted, ref } from "vue";

const props = defineProps({
  setting: Object,
});

const { updateSettingDefinition } = useClients();
const emit = defineEmits(['closeDialog']);
const dialog = ref(true);
const saving = ref(false);
const newDefinition = ref({});

onMounted(() => {
  newDefinition.value = { ...props.setting};
})

const saveSettingDefinition = async () => {
  saving.value = true;
  try {
    const params = { model_type: props.setting.model_type }
    if (props.setting.description !== newDefinition.value.description) {
      params.description = newDefinition.value.description;
    }
    if (props.setting.category !== newDefinition.value.category) {
      params.category = newDefinition.value.category;
    }
    
    const response = await updateSettingDefinition(props.setting.id, params);
    if (response) {
      emit('closeDialog');
    }
  } finally {
    saving.value = false;
  }
}

const hasChanges = computed(() => {
  // Ensure we have the objects to compare
  if (!props.setting || !newDefinition.value.key) {
    return false;
  }
  
  const descriptionChanged = props.setting.description !== newDefinition.value.description;
  const categoryChanged = props.setting.category !== newDefinition.value.category;
  
  return descriptionChanged || categoryChanged;
});
</script>

<template>
  <v-dialog v-model="dialog" max-width="600" persistent>
    <v-card>
      <v-card-title class="border-b bg-surface-light px-4 py-4 text-h5">Update Settings Description and Category</v-card-title>
      <v-card-text class="border-b">
        <v-row class="align-center">
          <v-col cols="4">
            <label>Setting Key</label>
          </v-col>
          <v-col cols="8">
            <v-text-field 
              disabled
              v-model="newDefinition.key"
              variant="outlined" 
              density="comfortable"
              hide-details="auto"
            />
          </v-col>
          <v-col cols="4">
            <label for="description">Description</label>
          </v-col>
          <v-col cols="8">
            <v-text-field 
              id="description"
              v-model="newDefinition.description"
              density="comfortable"
              variant="outlined" 
              hide-details="auto" 
            />
          </v-col>
          <v-col cols="4">
            <label for="category">Category</label>
          </v-col>
          <v-col cols="8">
            <v-select
              id="category"
              v-model="newDefinition.category"
              :items="SETTING_DEFINITIONS_CATEGORIES"
              density="comfortable"
              variant="outlined"
              hide-details="auto"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <template v-slot:actions>
        <v-btn
          color="red"
          class="ml-auto"
          variant="text"
          @click="emit('closeDialog')"
        > 
          Cancel
        </v-btn>
        <v-btn
          color="green"
          variant="text"
          @click="saveSettingDefinition"
          :loading="saving"
          :disabled="!hasChanges || saving"
        >
          Save
        </v-btn>
      </template>
    </v-card>
  </v-dialog>
</template>
